import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import FileUpload from '../components/features/home/FileUpload';
import { 
  HomeContainer, 
  ContentContainer, 
  ToggleContainer,
  ToggleButtons,
  ToggleButton,
  TableContainer,
  ResultsTable,
  Th
} from '../styles/HomeStyles';
import { useAnalyses } from '../hooks/useAnalyses';
import TableRow from '../components/features/home/TableRow';
import { LoadingSpinner, ErrorMessage } from '../styles/HomeStyles';

const Home = () => {
  const [activeTab, setActiveTab] = useState('history');

  const { data, loading, error, refetch } = useAnalyses(activeTab);

  const tabs = [
    { id: 'history', label: 'Personal History' },
    { id: 'bookmarks', label: 'Bookmarks' }
  ];

  return (
    <HomeContainer>
      <Navbar />
      <ContentContainer>
        <FileUpload onUploadSuccess={refetch} />

        <ToggleContainer>
          <ToggleButtons>
            {tabs.map(tab => (
              <ToggleButton
                key={tab.id}
                active={activeTab === tab.id}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </ToggleButton>
            ))}
          </ToggleButtons>
        </ToggleContainer>

        <TableContainer>
          {loading ? (
            <LoadingSpinner>Loading...</LoadingSpinner>
          ) : error ? (
            <ErrorMessage>{error}</ErrorMessage>
          ) : data.length === 0 ? (
            <div>No analyses found</div>
          ) : (
            <ResultsTable>
              <thead>
                <tr>
                  <Th>Icon</Th>
                  <Th>SHA256</Th>
                  <Th>Package Name</Th>
                  <Th>App Name</Th>
                  <Th>Malware Family</Th>
                  <Th>Status</Th>
                  <Th>Analysis Date</Th>
                  <Th>Intelligence</Th>
                </tr>
              </thead>
              <tbody>
                {data.map(analysis => (
                  <TableRow 
                    key={analysis.sha256} 
                    analysis={analysis} 
                  />
                ))}
              </tbody>
            </ResultsTable>
          )}
        </TableContainer>
      </ContentContainer>
    </HomeContainer>
  );
};

export default Home;